var _rect, _rect2, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBillingDomain(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 19.5,
    fill: "#262626"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 19.5,
    stroke: "#404040"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.155 24.5117C11.8424 24.8242 11.6668 25.248 11.6667 25.69V27.5C11.6667 27.9599 12.0401 28.3333 12.5 28.3333H15C15.4599 28.3333 15.8333 27.9599 15.8333 27.5V26.6667C15.8333 26.2067 16.2067 25.8333 16.6667 25.8333H17.5C17.9599 25.8333 18.3333 25.4599 18.3333 25V24.1667C18.3333 23.7067 18.7067 23.3333 19.1667 23.3333H19.31C19.752 23.3332 20.1758 23.1576 20.4883 22.845L21.1667 22.1667C23.5518 22.9975 26.1947 22.0697 27.537 19.9301C28.8793 17.7906 28.5647 15.0073 26.7787 13.2213C24.9927 11.4353 22.2094 11.1207 20.0699 12.463C17.9303 13.8053 17.0025 16.4482 17.8333 18.8333",
    stroke: "#D4D4D4",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3333 16.25C23.3333 16.48 23.52 16.6667 23.75 16.6667C23.98 16.6667 24.1667 16.48 24.1667 16.25C24.1667 16.02 23.98 15.8333 23.75 15.8333C23.52 15.8333 23.3333 16.02 23.3333 16.25Z",
    fill: "#D4D4D4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3333 16.25C23.3333 16.48 23.52 16.6667 23.75 16.6667C23.98 16.6667 24.1667 16.48 24.1667 16.25C24.1667 16.02 23.98 15.8333 23.75 15.8333C23.52 15.8333 23.3333 16.02 23.3333 16.25",
    stroke: "#D4D4D4",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBillingDomain);
export default __webpack_public_path__ + "static/media/billing-domain.54941f87d6a96ad25215582f3ddcb18f.svg";
export { ForwardRef as ReactComponent };